import { guid, calcPercentile } from '../utils';

export const SELENIUM_PERF_MARKS = {
    GET_BROWSER: 'GET_BROWSER',
    GET_HTML: 'GET_HTML',
    GET_ELEMENT: 'GET_ELEMENT',
    GET_SCREENSHOT: 'GET_SCREENSHOT',
} as const;

type SeleniumPrefMark = typeof SELENIUM_PERF_MARKS[keyof typeof SELENIUM_PERF_MARKS];
type SeleniumPrefMarkAndAll = SeleniumPrefMark | 'ALL';

export interface SeleniumPerfStatValues extends ReturnType<SeleniumPerfStats['getStats']> {}

const performanceKeys: SeleniumPrefMarkAndAll[] = ['ALL', ...Object.values(SELENIUM_PERF_MARKS)];

export class SeleniumPerfStats {
    public marks: { [mark in SeleniumPrefMarkAndAll]: number[] } = Object.fromEntries<number[]>(performanceKeys.map(key => [key, []])) as any;
    private startTimes: { [mark: string]: number } = {};

    public markStart(mark?: SeleniumPrefMark) {
        const id = guid();
        this.startTimes[`${mark}:${id}`] = Date.now();
        return id;
    }

    public markEnd(id: string, mark?: SeleniumPrefMark) {
        const markDuration = Date.now() - this.startTimes[`${mark}:${id}`];
        delete this.startTimes[`${mark}:${id}`];

        if (!this.marks[mark!]) {
            this.marks.ALL.push(markDuration);
            return;
        }
        this.marks[mark!].push(markDuration);
    }

    public getStats() {
        const entries = Object.entries(this.marks).flatMap(([key, samples]) => {
            if (!Array.isArray(samples) || !samples.length) {
                return [];
            }
            return [
                [`${key}_COUNT`, samples.length],
                [`${key}_P50`, calcPercentile(samples, 50)],
                [`${key}_P95`, calcPercentile(samples, 95)],
            ];
        });
        type Stat = 'COUNT' | 'P50' | 'P95';
        return {
            seleniumPerfMarks: this.marks,
            seleniumStats: Object.fromEntries(entries) as { [stat in `${SeleniumPrefMarkAndAll}_${Stat}`]?: number },
        };
    }
}

